import * as GroupType from 'constants/GroupType';

const FOOTBALL_GROUP_MAP = {};

FOOTBALL_GROUP_MAP[0] = GroupType.DEFAULT_GROUP;
FOOTBALL_GROUP_MAP[1] = GroupType.FIRST_PERIOD_GROUP;
FOOTBALL_GROUP_MAP[2] = GroupType.SECOND_PERIOD_GROUP;
FOOTBALL_GROUP_MAP[3] = GroupType.FIRST_MINI_MATCH_GROUP;
FOOTBALL_GROUP_MAP[4] = GroupType.SECOND_MINI_MATCH_GROUP;
FOOTBALL_GROUP_MAP[5] = GroupType.THIRD_MINI_MATCH_GROUP;
FOOTBALL_GROUP_MAP[6] = GroupType.FOURTH_MINI_MATCH_GROUP;
FOOTBALL_GROUP_MAP[7] = GroupType.FIFTH_MINI_MATCH_GROUP;
FOOTBALL_GROUP_MAP[8] = GroupType.SIXTH_MINI_MATCH_GROUP;
FOOTBALL_GROUP_MAP[9] = GroupType.CORNER_GROUP;
FOOTBALL_GROUP_MAP[10] = GroupType.FIRST_PERIOD_CORNER_GROUP;
FOOTBALL_GROUP_MAP[11] = GroupType.YELLOW_CARD_GROUP;
FOOTBALL_GROUP_MAP[12] = GroupType.FIRST_PERIOD_YELLOW_CARD_GROUP;
FOOTBALL_GROUP_MAP[13] = GroupType.OVERTIME_GROUP;
FOOTBALL_GROUP_MAP[14] = GroupType.FIRST_OVERTIME_GROUP;
FOOTBALL_GROUP_MAP[15] = GroupType.SECOND_OVERTIME_GROUP;
FOOTBALL_GROUP_MAP[16] = GroupType.PENALTIES_GROUP;

export default FOOTBALL_GROUP_MAP;


// WEBPACK FOOTER //
// ./js/sport-betting/components/grid-control/sportGlossary/Football/GroupMap.js